<section class="first" [formGroup]="form">
  <div class="lbl">Page</div>
  <!-- Sub-region and place pages aren't one suburb on the map, so they name themselves and pick a region. -->
  <div *ngIf="!fromMap" class="grid formgrid">
    <div class="field col-12 md:col-6">
      <label class="sub" for="sp-name">Name</label>
      <input id="sp-name" pInputText formControlName="name" type="text" class="w-full" (input)="nameInput.emit()" [class.ng-dirty]="invalid('name')" placeholder="Inner West" />
    </div>
    <div class="field col-12 md:col-6">
      <label class="sub">Region</label>
      <p-dropdown formControlName="regionId" [options]="regionOptions" optionLabel="label" optionValue="value" placeholder="Select a region" styleClass="w-full" appendTo="body" [baseZIndex]="12000"></p-dropdown>
      <small *ngIf="regionNote" class="note">{{ regionNote }}</small>
    </div>
  </div>

  <div class="field">
    <label class="sub" for="sp-slug">Address</label>
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon font-mono text-sm">{{ pathPrefix }}</span>
      <input id="sp-slug" pInputText formControlName="slug" type="text" class="font-mono" [class.ng-dirty]="invalid('slug')" placeholder="randwick" />
    </div>
    <small *ngIf="renamingFrom" class="note rename-note"><i class="pi pi-directions"></i> This page is on the website: its old addresses ending "/{{ renamingFrom }}" will redirect to the new one when you publish.</small>
    <small *ngIf="slugClash" class="note rename-note subregion-slug-clash"><i class="pi pi-exclamation-triangle"></i> A suburb of that name is in this state: at this address the sub-region's page takes the place of that suburb's own page.</small>
  </div>

  <div class="field">
    <label class="sub" for="sp-in-sentence">In a sentence</label>
    <input id="sp-in-sentence" pInputText formControlName="inSentence" type="text" class="w-full subregion-in-sentence" placeholder="the Eastern Suburbs" />
    <small class="note">How the page is named mid-sentence: the template's <code>{{ whereToken }}</code>, as in "Suburbs in the Eastern Suburbs". Blank uses its name.</small>
  </div>

  <div class="field">
    <label class="sub" for="sp-description">Description <span class="meta-inline">search results, ~155 characters</span></label>
    <textarea id="sp-description" pInputTextarea formControlName="seoDescription" rows="2" class="w-full"></textarea>
    <small class="note">Blank uses the opening paragraph, else the template's description.</small>
  </div>

  <label class="switch-row">
    <p-inputSwitch formControlName="noindex"></p-inputSwitch>
    <span>Hide from search</span>
  </label>
</section>
